import CustomStore from 'devextreme/data/custom_store';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from '~/services/api';
import { handleError, handleParams } from '~/services/helper';
import store from '~/store/Store';

export async function handleRegisterPage(page, setLoading) {
  await api
    .post('/Pagina', page)
    .then(() => {
      setLoading(false);
      toast.success('Página cadastrada com sucesso');
    })
    .catch(() => {
      toast.error('Erro ao cadastrar página');
      setLoading(false);
    });
}

export async function handleDeletePage() {
  const id = store.getState().Paginas.idPagina;
  toast.info('Excluindo página...');
  await api
    .delete(`Pagina/${id}`)
    .then(() => {
      toast.success('Sucesso ao excluir página');
    })
    .catch(() => {
      toast.error('Erro ao excluir página, tente novamente');
    });
}

export async function handleUpdatePage(setLoading, page) {
  setLoading(true);
  await api
    .put('/Pagina', page)
    .then(() => {
      setLoading(false);
      toast.success('Página cadastrada com sucesso');
    })
    .catch(() => {
      toast.error('Erro ao cadastrar página');
      setLoading(false);
    });
}

function handleLoadModuloData(loadOptions) {
  const idModulo = store.getState().Paginas.idModuloPagina;
  const params = {
    idModulo,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `Pagina?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

async function handleDeletePagina(key) {
  const url = `Pagina/${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Página deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridPaginaDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadModuloData(loadOptions),
    remove: (key) => handleDeletePagina(key),
  }),
};
